module.exports = __webpack_public_path__ + "img/jsjn.be161963.png";